import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronLeft } from 'shared/assets/icons';
import { Colors, IconButton, Sizes } from 'shared/components/ui/icon-button';

export type DisclosureButtonProps = {
  open: boolean;
  onToggle: (e: React.MouseEvent) => void;
  label: string;
  className?: string;
  color?: Colors;
};

export const DisclosureButton: React.FC<DisclosureButtonProps> = ({
  open,
  onToggle,
  label,
  className,
  color,
}) => {
  const { t } = useTranslation();

  return (
    <IconButton
      onClick={onToggle}
      icon={ChevronLeft}
      rotation={open ? -90 : 0}
      size={Sizes.Small}
      className={className}
      color={color}
      aria-expanded={open}
      aria-label={t(
        open
          ? 'general.menu.navigation.collapse-section'
          : 'general.menu.navigation.expand-section',
        { label },
      )}
    />
  );
};
